import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CoralDemo from "@/components/CoralDemo";
import ExtensionDownloadPage from "@/components/ExtensionDownloadPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/extension" element={<ExtensionDownloadPage />} />
          <Route path="/*" element={<CoralDemo />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
